import React, { Component } from "react";
import axios from "axios";
import "./PlanSubscription.css";
import Util from "../../util/util";
import moment from "moment";
import Calendar from "../../components/calendar/Calendar";

class PlanSubscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: "",
      allUsers: [],
      showInputData: false,
      usersToPay: [],
      usersExpired: [],
      oneuser: [],
      showCalendar: false,
      nameError: "",
      user: [],
      users_list: [],
      user_id: "",
      user_address: "",
      user_username: "",
      user_phone: "",
      user_jib: "",
      user_email: "",
      user_pdv: "",
      facture_number: "",
      facture_address: "",
      user_logged: "",
      start_date: "",
      userInfo: [],
      endDate: "",
      showPay: false,
      lost_months: "",
      collect: [],
      showFirstPay: false,
      firstDate: "",
      newName: "",
      isAdmin: false,
      loggedUser: "",
      loggedUserId: "",
      addingPDF: false,
    };
  }
  componentDidMount = () => {
    var is_admin = localStorage.getItem("user_data")
      ? JSON.parse(localStorage.getItem("user_data"))
        ? JSON.parse(localStorage.getItem("user_data")).is_admin
          ? true
          : false
        : false
      : false;

    var loggedUser = localStorage.getItem("user_data");
    var loggedUserId = JSON.parse(localStorage.getItem("user_data")).id;

    this.setState({
      oneuser: [],
      user_id: "",
      collect: [],
      readyMessage: "",
      isAdmin: is_admin,
      loggedUserId: loggedUserId,
      loggedUser: loggedUser,
      newName: "",
      addingPDF: false,
    });
    if (is_admin == 1) {
      var mainThis = this;
      axios
        .get(window.ajaxLink + "user/getAllUsersMonth")
        .then((res) => {
          if (res["data"] && res["data"]["responseData"]) {
            mainThis.setState({ allUsers: res["data"]["responseData"] });
          }
        })
        .catch((err) => {});

      axios
        .get(window.ajaxLink + "user/payingUser")
        .then((res) => {
          if (res["data"] && res["data"]["responseData"]) {
            mainThis.setState({ usersToPay: res["data"]["responseData"] });
          }
        })
        .catch((err) => {});

      axios
        .get(window.ajaxLink + "user/expiredUser")
        .then((res) => {
          if (res["data"] && res["data"]["responseData"]) {
            mainThis.setState({ usersExpired: res["data"]["responseData"] });
          }
        })
        .catch((err) => {});

      axios
        .get(window.ajaxLink + "user/userlist")
        .then((res) => {
          if (res["data"] && res["data"]["responseData"]) {
            mainThis.setState({ users_list: res["data"]["responseData"] });
          }
        })
        .catch((err) => {});
    }

    var currentTabHref = "users";

    if (window.location.hash == "#isteklo") {
      currentTabHref = "expired";
    }

    if (window.location.hash == "#korisnickoplacanje") {
      currentTabHref = "to_pay";
    }
    if (window.location.hash == "#predistek") {
      currentTabHref = "check";
    }
    this.setState({ currentTab: currentTabHref });
    this.getCurrentTime();
  };

  getCurrentTime = () => {
    var current = new Date();
    var date = current.getFullYear() + "/" + (current.getMonth() + 1) + "/" + current.getDate();
    this.setState({ endDate: date });
    return date;
  };

  showpPayingPopup = (oneuser) => {
    if (this.state.isAdmin == 1) {
      this.setState(
        {
          showInputData: true,
          oneuser: oneuser,
          user_address: "",
          user_username: "",
          user_phone: "",
          user_jib: "",
          user_email: "",
          user_pdv: "",
          facture_number: "",
          facture_address: "",
          start_date: "",
        },
        this.updateUsers()
      );
    }
  };

  showNotPayingPopup = (oneuser) => {
    Util.showPopupDialog(
      "Potvrdite",
      "Da li ste sigurni da želite da prebacite ovog korisnika u listu za neplaćanje?",
      {
        title: "Prebaci",
        css: "middle_popup_blue_button",
        callback: () => {
          this.notpayWindow(oneuser);
        },
      },
      {
        title: "Otkaži",
        css: "middle_popup_yellow_button",
        callback: () => {},
      },
      () => {}
    );
    this.updateUsers();
  };

  payingWindow = (user) => {
    var mainThis = this;
    axios
      .post(window.ajaxLink + "user/getUsersViaId", {
        user: user.id,
        loggedUserId: this.state.loggedUserId,
      })
      .then((res) => {
        mainThis.setState({
          usersToPay: res["data"]["responseData"],
        });
      });
    this.updateUsers();
  };

  newMonth = (date) => {
    var newDate = moment(new Date(date)).format("YYYY/MM/DD");
    var fullD = Util.defDate(newDate);
    var nd = moment(fullD).format("YYYY/MM/DD");

    return nd;
  };

  directPaying = (oneUser) => {
    var mainThis = this;
    axios
      .post(window.ajaxLink + "user/getDirectPaying", {
        id: oneUser.userid,
        date: this.newMonth(oneUser.last_payment),
        loggedUserId: this.state.loggedUserId,
      })
      .then((res) => {
        mainThis.setState({ users_list: res["data"]["responseData"] });
      });

    Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
      title: "U redu",
      css: "middle_popup_blue_button",
      callback: () => {},
    });
    this.checkMonths(oneUser);
    this.updateUsers();
  };

  notpayWindow = (user) => {
    var endDate = this.getCurrentTime();
    var mainThis = this;
    axios
      .post(window.ajaxLink + "user/getUsersViaIdExpired", {
        user: user,
        endDate: endDate,
        loggedUserId: this.state.loggedUserId,
      })
      .then((res) => {
        mainThis.setState({
          usersExpired: res["data"]["responseData"],
        });
      });
    this.updateUsers();
  };

  backToUsers = () => {
    this.setState({
      showInputData: false,
      showPay: false,
      showFirstPay: false,
    });
    this.updateUsers();
  };

  handleChangeUsername = (e) => {
    var name = e.target.value;
    this.setState({ user_username: name });
  };

  handleChangeAddress = (e) => {
    var address = e.target.value;
    this.setState({ user_address: address });
  };

  handleChangeJIB = (e) => {
    var jib = e.target.value;
    this.setState({ user_jib: jib });
  };

  handleChangePDV = (e) => {
    var pdv = e.target.value;
    this.setState({ user_pdv: pdv });
  };

  handleChangePhone = (e) => {
    var phone = e.target.value;
    this.setState({ user_phone: phone });
  };

  handleChangeEmail = (e) => {
    var email = e.target.value;
    this.setState({ user_email: email });
  };

  handleChangeReg = (e) => {
    var reg = e.target.value;
    this.setState({ start_date: reg, firstDate: reg });
  };

  handleChangeFacture = (e) => {
    var fact = e.target.value;
    this.setState({ facture_address: fact });
  };

  handleChangeFactureNumber = (e) => {
    var number = e.target.value;
    this.setState({ facture_number: number });
  };

  showCalendar = () => {
    var showHide = this.state.showCalendar;
    showHide = !showHide;
    this.setState({ showCalendar: showHide, user_logged: "" });
  };

  factureData = () => {
    var allGood = true;
    var x = "";
    if (this.state.user_id == "") {
      allGood = false;
    }
    if (this.state.user_username == "") {
      allGood = false;
      x += ",greska u imenu";
    }
    if (this.start_date == "") {
      allGood = false;
    }
    if (allGood == true) {
      var information = {
        id: this.state.user_id,
        username: this.state.user_username,
        address: this.state.user_address,
        JIB: this.state.user_jib,
        pdv: this.state.user_pdv,
        phone: this.state.user_phone,
        start_date: this.state.start_date,
        email: this.state.user_email,
        facture_number: this.state.facture_number,
        facture_address: this.state.facture_address,
      };
      this.setState({ userInfo: information }, this.sendFactureData);
    } else {
      alert("Molimo provjerite unesene podatke " + x);
    }
    this.updateUsers();
  };

  sendFactureData = () => {
    var mainThis = this;
    axios
      .post(window.ajaxLink + "user/updateUserTable", {
        user: this.state.userInfo,
        loggedUserId: this.state.loggedUserId,
      })
      .then((res) => {
        if (res["data"]["responseData"]) {
          mainThis.setState({
            user: res["data"]["responseData"],
          });
        }
      })
      .catch((err) => {});
    alert("Podaci su uspiješno sačuvani!");

    this.setState({ showInputData: false });
    this.payingWindow(this.state.oneuser);
  };

  updateUsers = () => {
    if (this.state.isAdmin == 1) {
      var mainThis = this;
      axios
        .get(window.ajaxLink + "user/getAllUsersMonth")
        .then((res) => {
          if (res["data"] && res["data"]["responseData"]) {
            mainThis.setState({ allUsers: res["data"]["responseData"] });
          }
        })
        .catch((err) => {});

      axios
        .get(window.ajaxLink + "user/payingUser")
        .then((res) => {
          if (res["data"] && res["data"]["responseData"]) {
            mainThis.setState({ usersToPay: res["data"]["responseData"] });
          }
        })
        .catch((err) => {});

      axios
        .get(window.ajaxLink + "user/expiredUser")
        .then((res) => {
          if (res["data"] && res["data"]["responseData"]) {
            mainThis.setState({ usersExpired: res["data"]["responseData"] });
          }
        })
        .catch((err) => {});

      axios
        .get(window.ajaxLink + "user/userlist")
        .then((res) => {
          if (res["data"] && res["data"]["responseData"]) {
            mainThis.setState({ users_list: res["data"]["responseData"] });
          }
        })
        .catch((err) => {});
    }
  };

  updateChild = (val, callback) => {
    if (callback) {
      this.setState(val, callback);
    } else {
      this.setState(val);
    }
  };

  firstPayment = () => {
    this.setState({ showFirstPay: false });
    var id = this.state.user_id;
    var date = this.state.firstDate;
    var mainThis = this;
    axios
      .post(window.ajaxLink + "user/userMonths", {
        id: id,
        date: date,
        loggedUserId: this.state.loggedUserId,
      })
      .then((res) => {
        if (res["data"]["responseData"]) {
          mainThis.setState({
            user: res["data"]["responseData"],
          });
        }
      })
      .catch((err) => {});
    axios
      .post(window.ajaxLink + "user/getDirectPaying", {
        id: id,
        date: date,
        loggedUserId: this.state.loggedUserId,
      })
      .then((res) => {
        mainThis.setState({ users_list: res["data"]["responseData"] });
      });
    this.updateUsers();
  };
  checkMonths = (oneUser) => {
    var mainThis = this;
    axios
      .post(window.ajaxLink + "user/userMonths", {
        id: oneUser.userid,
        date: this.newMonth(oneUser.last_payment),
        loggedUserId: this.state.loggedUserId,
      })
      .then((res) => {
        if (res["data"]["responseData"]) {
          mainThis.setState({
            user: res["data"]["responseData"],
          });
        }
      })
      .catch((err) => {});
  };

  differenceInTime = (payday) => {
    var pay_date = new Date(payday);
    var today = new Date();
    var difference = today.getTime() - pay_date.getTime();
    var difference_in_days = Math.floor(difference / (1000 * 3600 * 24));
    return difference_in_days;
  };

  lostPaymentpopup = (oneUser) => {
    var months = [];
    var addMonth;
    var userid = oneUser.userid;
    var last = oneUser.last_payment;
    var date = new Date(last);
    var day = date.getDate();
    var year = date.getFullYear();

    if (oneUser.first_month == "0000-00-00") {
      addMonth = year + "-01-" + Util.correctDate(year, 1, day);
      months.push(addMonth);
    }
    if (oneUser.second_month == "0000-00-00") {
      addMonth = year + "-02-" + Util.correctDate(year, 2, day);
      months.push(addMonth);
    }
    if (oneUser.third_month == "0000-00-00") {
      addMonth = year + "-03-" + Util.correctDate(year, 3, day);
      months.push(addMonth);
    }
    if (oneUser.fourth_month == "0000-00-00") {
      addMonth = year + "-04-" + Util.correctDate(year, 4, day);
      months.push(addMonth);
    }
    if (oneUser.fifth_month == "0000-00-00") {
      addMonth = year + "-05-" + Util.correctDate(year, 5, day);
      months.push(addMonth);
    }
    if (oneUser.sixth_month == "0000-00-00") {
      addMonth = year + "-06-" + Util.correctDate(year, 6, day);
      months.push(addMonth);
    }
    if (oneUser.seventh_month == "0000-00-00") {
      addMonth = year + "-07-" + Util.correctDate(year, 7, day);
      months.push(addMonth);
    }
    if (oneUser.eighth_month == "0000-00-00") {
      addMonth = year + "-08-" + Util.correctDate(year, 8, day);
      months.push(addMonth);
    }
    if (oneUser.ninth_month == "0000-00-00") {
      addMonth = year + "-09-" + Util.correctDate(year, 9, day);
      months.push(addMonth);
    }
    if (oneUser.tenth_month == "0000-00-00") {
      addMonth = year + "-10-" + Util.correctDate(year, 10, day);
      months.push(addMonth);
    }
    if (oneUser.eleventh_month == "0000-00-00") {
      addMonth = year + "-11-" + Util.correctDate(year, 11, day);
      months.push(addMonth);
    }
    if (oneUser.twelfth_month == "0000-00-00") {
      addMonth = year + "-12-" + Util.correctDate(year, 12, day);
      months.push(addMonth);
    }
    this.setState({ lost_months: months, userid: userid });
    this.updateUsers();
  };

  handleChekbox = (e) => {
    var collect = this.state.collect;
    var x = e.target.value;
    collect.push(x);
    this.setState({ collect: collect });
  };

  markAsPayed(date, userid) {
    var mainThis = this;
    axios
      .post(window.ajaxLink + "user/markAsPayed", {
        id: userid,
        date: date,
        loggedUserId: this.state.loggedUserId,
      })
      .then((res) => {
        if (res["data"]["responseData"]) {
          mainThis.setState({
            //  user: res["data"]["responseData"],
          });
          this.updateUsers();
        }
      })
      .catch((err) => {});
  }

  payLostMonths = () => {
    var months = this.state.collect;
    var userid = this.state.userid;
    var mainThis = this;
    axios
      .post(window.ajaxLink + "user/lostMonths", {
        id: userid,
        date: months,
        loggedUserId: this.state.loggedUserId,
      })
      .then((res) => {
        if (res["data"]["responseData"]) {
          mainThis.setState({
            user: res["data"]["responseData"],
          });
        }
      })
      .catch((err) => {});
    this.setState({ collect: [], showPay: false });
    this.updateUsers();
  };

  returnUnpayedDate = (control, date) => {
    if (date.last_payment != "0000-00-00") {
      var datedate = date.last_payment;
      var newDate = new Date(datedate);
      var day = newDate.getDate();
      var year = newDate.getFullYear();
    } else {
      var date2 = date.start_date;
      newDate = new Date(date2);
      day = newDate.getDate();
      year = newDate.getFullYear();
    }
    if (control == "januar") {
      var fullDate = year + "-01-" + Util.correctDate(year, 1, day);
    }
    if (control == "februar") {
      fullDate = year + "-02-" + Util.correctDate(year, 2, day);
    }
    if (control == "mart") {
      fullDate = year + "-03-" + Util.correctDate(year, 3, day);
    }
    if (control == "april") {
      fullDate = year + "-04-" + Util.correctDate(year, 4, day);
    }
    if (control == "maj") {
      fullDate = year + "-05-" + Util.correctDate(year, 5, day);
    }
    if (control == "jun") {
      fullDate = year + "-06-" + Util.correctDate(year, 6, day);
    }
    if (control == "jul") {
      fullDate = year + "-07-" + Util.correctDate(year, 7, day);
    }
    if (control == "avgust") {
      fullDate = year + "-08-" + Util.correctDate(year, 8, day);
    }
    if (control == "septembar") {
      fullDate = year + "-09-" + Util.correctDate(year, 9, day);
    }
    if (control == "oktobar") {
      fullDate = year + "-10-" + Util.correctDate(year, 10, day);
    }
    if (control == "novembar") {
      fullDate = year + "-11-" + Util.correctDate(year, 11, day);
    }
    if (control == "decembar") {
      fullDate = year + "-12-" + Util.correctDate(year, 12, day);
    }
    if (control == "newYear") {
      year = year + 1;
      fullDate = year + "-1-" + Util.correctDate(year, 1, day);
    }
    return fullDate;
  };

  generatePdf = (date, id, username, priceType) => {
    var mainThis = this;
    axios
      .post(window.ajaxLink + "user/generatePdf", {
        id: id,
        date: date,
        loggedUserId: this.state.loggedUserId,
        price: priceType,
      })
      .then((res) => {
        mainThis.setState({
          newName: res["data"]["responseData"],
          addingPDF: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
    setTimeout(() => {
      this.onButtonClick(this.state.newName);
    }, 4000);
  };

  generateTaxPdf = (date, id, username, priceType) => {
    var payment = moment().format("YYYY-MM-DD");
/*    
    var dated = new Date(paymentDate);
    console.log("addajksdkahsdkjasdh", dated);
    var pp = dated.setDate(13);
    var date1 = new Date("2023-06-14");
    console.log("a*********************", moment(date1).format("YYYY-MM-DD"));
    var dateeeee = moment(date1).format("YYYY-MM-DD"); */
    var mainThis = this;
    axios
      .post(window.ajaxLink + "user/generateTaxPdf", {
        id: id,
        date: date,
        paymentDate: date,
        currentDate:payment,
        loggedUserId: this.state.loggedUserId,
        price: priceType,
      })
      .then((res) => {
        mainThis.setState({
          newName: res["data"]["responseData"],
          addingPDF: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  findFacture = (date, id, username, priceType) => {
    var mainThis = this;
    axios
      .post(window.ajaxLink + "user/showTaxPDF", {
        id: id,
        date: date,
        loggedUserId: this.state.loggedUserId,
        price: priceType,
      })
      .then((res) => {
        mainThis.setState({
          newName: res["data"]["responseData"],
          addingPDF: true,
        });
      })
      .catch((err) => {
        console.log(err);
        Util.showPopupDialog("Obavještenje", "PDF nije pronađen", {
          title: "U redu",
          css: "middle_popup_blue_button",
          callback: () => {
            window.location.reload(true);
          },
        });
      });
    setTimeout(() => {
      this.onButtonClick(this.state.newName);
    }, 4000);
  };

  onButtonClick = (x) => {
    window.open(x);
    this.setState({ addingPDF: false });
  };

  render() {
    return (
      <>
        <div className="sub_plan_page">
          <div className="sub_plan_header">
            <div className="sub_plan_page_title">Plan pretplate</div>
          </div>
          <div className="sub_plan_sections">
            <a href="#korisnici">
              <div
                onClick={() => {
                  this.setState({ currentTab: "users" });
                }}
                className={this.state.currentTab == "users" ? "active" : ""}
              >
                Lista korisnika({this.state.allUsers.length})
              </div>
            </a>
            <a href="#korisnickoplacanje">
              <div
                onClick={() => {
                  this.setState({ currentTab: "to_pay" });
                }}
                className={this.state.currentTab == "to_pay" ? "active" : ""}
              >
                Plaćanje({this.state.usersToPay.length})
              </div>
            </a>
            <a href="#isteklo">
              <div
                onClick={() => {
                  this.setState({ currentTab: "expired" });
                }}
                className={this.state.currentTab == "expired" ? "active" : ""}
              >
                Isteklo({this.state.usersExpired.length})
              </div>
            </a>
            <a href="#predistek">
              <div
                onClick={() => {
                  this.setState({ currentTab: "check" });
                }}
                className={this.state.currentTab == "check" ? "active" : ""}
              >
                Pred istek({this.state.users_list.length})
              </div>
            </a>
          </div>
          {this.state.currentTab == "users" && (
            <div className="sub_plan_section">
              <div className="sub_plan_section_title">Lista korisnika</div>
              <div className="one_user_header_sub ">
                <div className="one_user_field_sub " style={{ width: "50px" }}>
                  ID
                </div>
                <div className="one_user_field_sub">Korisničko ime</div>
                <div className="one_user_field_sub">Email</div>
                <div className="one_user_field_sub">Telefon</div>
                <div className="one_user_field_sub">Registrovan</div>
                <div className="one_user_field_sub">Dodat prvi proizvod</div>
                <div className="one_user_field_sub">Poslednja aktivnost</div>
                <div className="one_user_field_sub last_item_sub">Status</div>
              </div>
              {this.state.allUsers.map((oneUser, i) => (
                <div className="one_user_item_sub" key={i}>
                  <div className="one_user_field_sub " style={{ width: "50px" }}>
                    {oneUser.id}
                  </div>
                  <div
                    style={{
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                    className="one_user_field_sub"
                  >
                    <span>{oneUser.username}</span>
                    <div className="users_name_lastname">
                      {oneUser.first_name} {oneUser.last_name}
                    </div>
                    <div
                      className="pay_button"
                      onClick={() => {
                        this.setState(
                          {
                            showInputData: true,
                            oneuser: oneUser,
                            user_id: oneUser.id,
                            user_logged: oneUser.registered,
                            start_date: Util.defDate(oneUser.registered),
                            last_pay: oneUser.last_date_payed,
                          },
                          this.showpPayingPopup(oneUser)
                        );
                      }}
                    >
                      Plaćanje
                    </div>
                    <div
                      className="refuse_pay_button"
                      onClick={() => {
                        this.showNotPayingPopup(oneUser.id);
                      }}
                    >
                      Ne želi
                    </div>
                  </div>
                  <div className="one_user_field_sub">{oneUser.email}</div>
                  <div className="one_user_field_sub">{oneUser.phone}</div>
                  <div className="one_user_field_sub">{Util.dateTimeFormat(oneUser.registered)}</div>
                  <div className="one_user_field_sub">{Util.dateTimeFormat(oneUser.first_product_added)}</div>
                  <div className="one_user_field_sub">{Util.dateTimeFormat(oneUser.last_time_logged)}</div>
                  <div className="one_user_field_sub last_item_sub">{oneUser.status}</div>
                </div>
              ))}
            </div>
          )}
          {this.state.currentTab == "to_pay" && (
            <div className="sub_plan_section">
              <div className="sub_plan_section_title pay_tab">Lista korisnika za plaćanje</div>
              <div className="one_user_header_sub pay_tab">
                <div className="one_user_field_sub " style={{ width: "50px" }}>
                  ID
                </div>
                <div className="one_user_field_sub">Korisničko ime</div>
                <div className="one_user_field_sub">Email</div>
                <div className="one_user_field_sub">Telefon</div>
                <div className="one_user_field_sub">Registrovan</div>
                <div className="one_user_field_sub">Dodat prvi proizvod</div>
                <div className="one_user_field_sub">Poslednja aktivnost</div>
                <div className="one_user_field_sub">Poslednja uplata</div>
                <div className="one_user_field_sub">Podešavanja</div>
                <div className="one_user_field_sub">1.mjesec</div>
                <div className="one_user_field_sub">2.mjesec</div>
                <div className="one_user_field_sub">3.mjesec</div>
                <div className="one_user_field_sub">4.mjesec</div>
                <div className="one_user_field_sub">5.mjesec</div>
                <div className="one_user_field_sub">6.mjesec</div>
                <div className="one_user_field_sub">7.mjesec</div>
                <div className="one_user_field_sub">8.mjesec</div>
                <div className="one_user_field_sub">9.mjesec</div>
                <div className="one_user_field_sub">10.mjesec</div>
                <div className="one_user_field_sub">11.mjesec</div>
                <div className="one_user_field_sub">12.mjesec</div>
                <div className="one_user_field_sub">Januar NG</div>
                <div className="one_user_field_sub">Broj fakture</div>
                <div className="one_user_field_sub">Adresa fakture</div>
                <div className="one_user_field_sub last_item_sub">Status</div>
              </div>
              {this.state.usersToPay.map((oneUser, i) => (
                <div className="one_user_item_sub pay_tab" key={i}>
                  <div className="one_user_field_sub" style={{ width: "50px" }}>
                    {oneUser.id}
                  </div>
                  <div
                    style={{
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                    className="one_user_field_sub"
                  >
                    <span>{oneUser.username}</span>
                    <div className="users_name_lastname">
                      {oneUser.first_name} {oneUser.last_name}
                    </div>
                    <div
                      className={"pay_button" + (oneUser.last_payment != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.setState({
                          showFirstPay: true,
                          user_id: oneUser.id,
                        });
                      }}
                    >
                      Prva uplata
                    </div>
                    <div
                      className="refuse_pay_button"
                      onClick={() => {
                        this.showNotPayingPopup(oneUser.id);
                      }}
                    >
                      Ne želi
                    </div>
                  </div>
                  <div className="one_user_field_sub">{oneUser.pay_email}</div>
                  <div className="one_user_field_sub">{oneUser.pay_phone}</div>
                  <div className="one_user_field_sub">{Util.dateTimeFormat(oneUser.registered)}</div>
                  <div className="one_user_field_sub">{Util.dateTimeFormat(oneUser.first_product_added)}</div>
                  <div className="one_user_field_sub">{Util.dateTimeFormat(oneUser.last_time_logged)}</div>

                  <div className="one_user_field_sub">{Util.dateFormat(oneUser.last_payment)}</div>
                  <div className="one_user_field_sub">
                    <div
                      className="pay_button"
                      onClick={() => {
                        this.setState(
                          {
                            showInputData: true,
                            oneuser: oneUser,
                            user_id: oneUser.id,
                            user_username: oneUser.pay_name,
                            start_date: oneUser.start_date,
                            user_jib: oneUser.pay_jib,
                            user_address: oneUser.pay_address,
                            user_pdv: oneUser.pdv,
                            facture_address: oneUser.facture_address,
                            facture_number: oneUser.facture_number,
                            user_phone: oneUser.pay_phone,
                            user_email: oneUser.pay_email,
                            user_logged: oneUser.registered,
                            last_pay: oneUser.last_date_payed,
                          },
                          this.showpPayingPopup(oneUser)
                        );
                      }}
                    >
                      Podešavanja
                    </div>
                  </div>
                  <div
                    className={
                      "one_user_field_sub" + (oneUser.first_month != "0000-00-00" ? " payed_month" : " unpayed_month")
                    }
                  >
                    {oneUser.first_month != "0000-00-00"
                      ? Util.dateFormat(oneUser.first_month)
                      : Util.dateFormat(this.returnUnpayedDate("januar", oneUser))}
                    <div
                      className={"pay_button" /* + (oneUser.first_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("januar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečni predračun
                    </div>
                    <div
                      className={"pay_button" /* + (oneUser.first_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("januar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Godišnji predračun
                    </div>
                    <div
                      className={"pay_button" + (oneUser.first_month != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.markAsPayed(this.returnUnpayedDate("januar", oneUser), oneUser.id);
                        Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
                          title: "U redu",
                          css: "middle_popup_blue_button",
                          callback: () => {
                            window.location.reload(true);
                          },
                        });
                        this.generateTaxPdf(
                          this.returnUnpayedDate("januar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        );
                      }}
                    >
                      Označi kao plaćeno
                    </div>
                    <div
                      className={"pay_button" + (oneUser.first_month == "0000-00-00" ? " d_none" : "")}
                      onClick={() =>
                        this.findFacture(
                          this.returnUnpayedDate("januar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečna faktura
                    </div>
                    {/*      <div
                      className={
                        "pay_button_none" +
                        (oneUser.first_month != "0000-00-00" &&
                        oneUser.second_month != "0000-00-00" &&
                        oneUser.third_month != "0000-00-00" &&
                        oneUser.fourth_month != "0000-00-00" &&
                        oneUser.fifth_month != "0000-00-00" &&
                        oneUser.sixth_month != "0000-00-00" &&
                        oneUser.seventh_month != "0000-00-00" &&
                        oneUser.eighth_month != "0000-00-00" &&
                        oneUser.ninth_month != "0000-00-00" &&
                        oneUser.tenth_month != "0000-00-00" &&
                        oneUser.eleventh_month != "0000-00-00" &&
                        oneUser.twelfth_month != "0000-00-00"
                          ? " d_block"
                          : "")
                      }
                      onClick={() =>
                        this.generateTaxPdf(
                          this.returnUnpayedDate("januar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Plaćena godišnja faktura
                    </div> */}
                  </div>
                  <div
                    className={
                      "one_user_field_sub" + (oneUser.second_month != "0000-00-00" ? " payed_month" : " unpayed_month")
                    }
                  >
                    {oneUser.second_month != "0000-00-00"
                      ? Util.dateFormat(oneUser.second_month)
                      : Util.dateFormat(this.returnUnpayedDate("februar", oneUser))}
                    <div
                      className={"pay_button" /* + (oneUser.second_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("februar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečni predračun
                    </div>
                    <div
                      className={"pay_button" /* + (oneUser.second_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("februar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Godišnji predračun
                    </div>
                    <div
                      className={"pay_button" + (oneUser.second_month != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.markAsPayed(this.returnUnpayedDate("februar", oneUser), oneUser.id);
                        Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
                          title: "U redu",
                          css: "middle_popup_blue_button",
                          callback: () => {
                            window.location.reload(true);
                          },
                        });
                        this.generateTaxPdf(
                          this.returnUnpayedDate("februar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        );
                      }}
                    >
                      Označi kao plaćeno
                    </div>
                    <div
                      className={"pay_button" + (oneUser.second_month == "0000-00-00" ? " d_none" : "")}
                      onClick={() =>
                        this.findFacture(
                          this.returnUnpayedDate("februar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečna faktura
                    </div>
                    {/*      <div
                      className={
                        "pay_button_none" +
                        (oneUser.first_month != "0000-00-00" &&
                        oneUser.second_month != "0000-00-00" &&
                        oneUser.third_month != "0000-00-00" &&
                        oneUser.fourth_month != "0000-00-00" &&
                        oneUser.fifth_month != "0000-00-00" &&
                        oneUser.sixth_month != "0000-00-00" &&
                        oneUser.seventh_month != "0000-00-00" &&
                        oneUser.eighth_month != "0000-00-00" &&
                        oneUser.ninth_month != "0000-00-00" &&
                        oneUser.tenth_month != "0000-00-00" &&
                        oneUser.eleventh_month != "0000-00-00" &&
                        oneUser.twelfth_month != "0000-00-00"
                          ? " d_block"
                          : "")
                      }
                      onClick={() =>
                        this.generateTaxPdf(
                          this.returnUnpayedDate("februar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Plaćena godišnja faktura
                    </div> */}
                  </div>
                  <div
                    className={
                      "one_user_field_sub" + (oneUser.third_month != "0000-00-00" ? " payed_month" : " unpayed_month")
                    }
                  >
                    {oneUser.third_month != "0000-00-00"
                      ? Util.dateFormat(oneUser.third_month)
                      : Util.dateFormat(this.returnUnpayedDate("mart", oneUser))}
                    <div
                      className={"pay_button" /* + (oneUser.third_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("mart", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečni predračun
                    </div>
                    <div
                      className={"pay_button" /* + (oneUser.third_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(this.returnUnpayedDate("mart", oneUser), oneUser.id, oneUser.username, "year")
                      }
                    >
                      Godišnji predračun
                    </div>
                    <div
                      className={"pay_button" + (oneUser.third_month != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.markAsPayed(this.returnUnpayedDate("mart", oneUser), oneUser.id);
                        Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
                          title: "U redu",
                          css: "middle_popup_blue_button",
                          callback: () => {
                            window.location.reload(true);
                          },
                        });
                        this.generateTaxPdf(
                          this.returnUnpayedDate("mart", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        );
                      }}
                    >
                      Označi kao plaćeno
                    </div>
                    <div
                      className={"pay_button" + (oneUser.third_month == "0000-00-00" ? " d_none" : "")}
                      onClick={() =>
                        this.findFacture(
                          this.returnUnpayedDate("mart", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečna faktura
                    </div>
                    {/*      <div
                      className={
                        "pay_button_none" +
                        (oneUser.first_month != "0000-00-00" &&
                        oneUser.second_month != "0000-00-00" &&
                        oneUser.third_month != "0000-00-00" &&
                        oneUser.fourth_month != "0000-00-00" &&
                        oneUser.fifth_month != "0000-00-00" &&
                        oneUser.sixth_month != "0000-00-00" &&
                        oneUser.seventh_month != "0000-00-00" &&
                        oneUser.eighth_month != "0000-00-00" &&
                        oneUser.ninth_month != "0000-00-00" &&
                        oneUser.tenth_month != "0000-00-00" &&
                        oneUser.eleventh_month != "0000-00-00" &&
                        oneUser.twelfth_month != "0000-00-00"
                          ? " d_block"
                          : "")
                      }
                      onClick={() =>
                        this.generateTaxPdf(
                          this.returnUnpayedDate("mart", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Plaćena godišnja faktura
                    </div> */}
                  </div>
                  <div
                    className={
                      "one_user_field_sub" + (oneUser.fourth_month != "0000-00-00" ? " payed_month" : " unpayed_month")
                    }
                  >
                    {oneUser.fourth_month != "0000-00-00"
                      ? Util.dateFormat(oneUser.fourth_month)
                      : Util.dateFormat(this.returnUnpayedDate("april", oneUser))}
                    <div
                      className={"pay_button" /* + (oneUser.fourth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("april", oneUser),

                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečni predračun
                    </div>
                    <div
                      className={"pay_button" /* + (oneUser.fourth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(this.returnUnpayedDate("april", oneUser), oneUser.id, oneUser.username, "year")
                      }
                    >
                      Godišnji predračun
                    </div>
                    <div
                      className={"pay_button" + (oneUser.fourth_month != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.markAsPayed(this.returnUnpayedDate("april", oneUser), oneUser.id);

                        Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
                          title: "U redu",
                          css: "middle_popup_blue_button",
                          callback: () => {
                            window.location.reload(true);
                          },
                        });
                        this.generateTaxPdf(
                          this.returnUnpayedDate("april", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        );
                      }}
                    >
                      Označi kao plaćeno
                    </div>
                    <div
                      className={"pay_button" + (oneUser.fourth_month == "0000-00-00" ? " d_none" : "")}
                      onClick={() =>
                        this.findFacture(
                          this.returnUnpayedDate("april", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečna faktura
                    </div>
                    {/*                     <div
                      className={
                        "pay_button_none" +
                        (oneUser.first_month != "0000-00-00" &&
                        oneUser.second_month != "0000-00-00" &&
                        oneUser.third_month != "0000-00-00" &&
                        oneUser.fourth_month != "0000-00-00" &&
                        oneUser.fifth_month != "0000-00-00" &&
                        oneUser.sixth_month != "0000-00-00" &&
                        oneUser.seventh_month != "0000-00-00" &&
                        oneUser.eighth_month != "0000-00-00" &&
                        oneUser.ninth_month != "0000-00-00" &&
                        oneUser.tenth_month != "0000-00-00" &&
                        oneUser.eleventh_month != "0000-00-00" &&
                        oneUser.twelfth_month != "0000-00-00"
                          ? " d_block"
                          : "")
                      }
                      onClick={() =>
                        this.generateTaxPdf(
                          this.returnUnpayedDate("april", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Plaćena godišnja faktura
                    </div> */}
                  </div>
                  <div
                    className={
                      "one_user_field_sub" + (oneUser.fifth_month != "0000-00-00" ? " payed_month" : " unpayed_month")
                    }
                  >
                    {oneUser.fifth_month != "0000-00-00"
                      ? Util.dateFormat(oneUser.fifth_month)
                      : Util.dateFormat(this.returnUnpayedDate("maj", oneUser))}
                    <div
                      className={"pay_button" /* + (oneUser.fifth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(this.returnUnpayedDate("maj", oneUser), oneUser.id, oneUser.username, "normal")
                      }
                    >
                      Mjesečni predračun
                    </div>
                    <div
                      className={"pay_button" /* + (oneUser.fifth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(this.returnUnpayedDate("maj", oneUser), oneUser.id, oneUser.username, "year")
                      }
                    >
                      Godišnji predračun
                    </div>
                    <div
                      className={"pay_button" + (oneUser.fifth_month != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.markAsPayed(this.returnUnpayedDate("maj", oneUser), oneUser.id);

                        Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
                          title: "U redu",
                          css: "middle_popup_blue_button",
                          callback: () => {
                            window.location.reload(true);
                          },
                        });
                        this.generateTaxPdf(
                          this.returnUnpayedDate("maj", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        );
                      }}
                    >
                      Označi kao plaćeno
                    </div>
                    <div
                      className={"pay_button" + (oneUser.fifth_month == "0000-00-00" ? " d_none" : "")}
                      onClick={() =>
                        this.findFacture(this.returnUnpayedDate("maj", oneUser), oneUser.id, oneUser.username, "normal")
                      }
                    >
                      Mjesečna faktura
                    </div>
                    {/*  <div
                      className={
                        "pay_button_none" +
                        (oneUser.first_month != "0000-00-00" &&
                        oneUser.second_month != "0000-00-00" &&
                        oneUser.third_month != "0000-00-00" &&
                        oneUser.fourth_month != "0000-00-00" &&
                        oneUser.fifth_month != "0000-00-00" &&
                        oneUser.sixth_month != "0000-00-00" &&
                        oneUser.seventh_month != "0000-00-00" &&
                        oneUser.eighth_month != "0000-00-00" &&
                        oneUser.ninth_month != "0000-00-00" &&
                        oneUser.tenth_month != "0000-00-00" &&
                        oneUser.eleventh_month != "0000-00-00" &&
                        oneUser.twelfth_month != "0000-00-00"
                          ? " d_block"
                          : "")
                      }
                      onClick={() =>
                        this.generateTaxPdf(
                          this.returnUnpayedDate("maj", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Plaćena godišnja faktura
                    </div> */}
                  </div>
                  <div
                    className={
                      "one_user_field_sub" + (oneUser.sixth_month != "0000-00-00" ? " payed_month" : " unpayed_month")
                    }
                  >
                    {oneUser.sixth_month != "0000-00-00"
                      ? Util.dateFormat(oneUser.sixth_month)
                      : Util.dateFormat(this.returnUnpayedDate("jun", oneUser))}
                    <div
                      className={"pay_button" /* + (oneUser.sixth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(this.returnUnpayedDate("jun", oneUser), oneUser.id, oneUser.username, "normal")
                      }
                    >
                      Mjesečni predračun
                    </div>
                    <div
                      className={"pay_button" /* + (oneUser.sixth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(this.returnUnpayedDate("jun", oneUser), oneUser.id, oneUser.username, "year")
                      }
                    >
                      Godišnji predračun
                    </div>
                    <div
                      className={"pay_button" + (oneUser.sixth_month != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.markAsPayed(this.returnUnpayedDate("jun", oneUser), oneUser.id);

                        Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
                          title: "U redu",
                          css: "middle_popup_blue_button",
                          callback: () => {
                            window.location.reload(true);
                          },
                        });
                        this.generateTaxPdf(
                          this.returnUnpayedDate("jun", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        );
                      }}
                    >
                      Označi kao plaćeno
                    </div>
                    <div
                      className={"pay_button" + (oneUser.sixth_month == "0000-00-00" ? " d_none" : "")}
                      onClick={() =>
                        this.findFacture(this.returnUnpayedDate("jun", oneUser), oneUser.id, oneUser.username, "normal")
                      }
                    >
                      Mjesečna faktura
                    </div>
                    {/*        <div
                      className={
                        "pay_button_none" +
                        (oneUser.first_month != "0000-00-00" &&
                        oneUser.second_month != "0000-00-00" &&
                        oneUser.third_month != "0000-00-00" &&
                        oneUser.fourth_month != "0000-00-00" &&
                        oneUser.fifth_month != "0000-00-00" &&
                        oneUser.sixth_month != "0000-00-00" &&
                        oneUser.seventh_month != "0000-00-00" &&
                        oneUser.eighth_month != "0000-00-00" &&
                        oneUser.ninth_month != "0000-00-00" &&
                        oneUser.tenth_month != "0000-00-00" &&
                        oneUser.eleventh_month != "0000-00-00" &&
                        oneUser.twelfth_month != "0000-00-00"
                          ? " d_block"
                          : "")
                      }
                      onClick={() =>
                        this.generateTaxPdf(
                          this.returnUnpayedDate("jun", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Plaćena godišnja faktura
                    </div> */}
                  </div>
                  <div
                    className={
                      "one_user_field_sub" + (oneUser.seventh_month != "0000-00-00" ? " payed_month" : " unpayed_month")
                    }
                  >
                    {oneUser.seventh_month != "0000-00-00"
                      ? Util.dateFormat(oneUser.seventh_month)
                      : Util.dateFormat(this.returnUnpayedDate("jul", oneUser))}
                    <div
                      className={"pay_button" /* + (oneUser.seventh_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(this.returnUnpayedDate("jul", oneUser), oneUser.id, oneUser.username, "normal")
                      }
                    >
                      Mjesečni predračun
                    </div>
                    <div
                      className={"pay_button" /* + (oneUser.seventh_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(this.returnUnpayedDate("jul", oneUser), oneUser.id, oneUser.username, "year")
                      }
                    >
                      Godišnji predračun
                    </div>
                    <div
                      className={"pay_button" + (oneUser.seventh_month != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.markAsPayed(this.returnUnpayedDate("jul", oneUser), oneUser.id);

                        Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
                          title: "U redu",
                          css: "middle_popup_blue_button",
                          callback: () => {
                            window.location.reload(true);
                          },
                        });
                        this.generateTaxPdf(
                          this.returnUnpayedDate("jul", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        );
                      }}
                    >
                      Označi kao plaćeno
                    </div>
                    <div
                      className={"pay_button" + (oneUser.seventh_month == "0000-00-00" ? " d_none" : "")}
                      onClick={() =>
                        this.findFacture(this.returnUnpayedDate("jul", oneUser), oneUser.id, oneUser.username, "normal")
                      }
                    >
                      Mjesečna faktura
                    </div>
                    {/*      <div
                      className={
                        "pay_button_none" +
                        (oneUser.first_month != "0000-00-00" &&
                        oneUser.second_month != "0000-00-00" &&
                        oneUser.third_month != "0000-00-00" &&
                        oneUser.fourth_month != "0000-00-00" &&
                        oneUser.fifth_month != "0000-00-00" &&
                        oneUser.sixth_month != "0000-00-00" &&
                        oneUser.seventh_month != "0000-00-00" &&
                        oneUser.eighth_month != "0000-00-00" &&
                        oneUser.ninth_month != "0000-00-00" &&
                        oneUser.tenth_month != "0000-00-00" &&
                        oneUser.eleventh_month != "0000-00-00" &&
                        oneUser.twelfth_month != "0000-00-00"
                          ? " d_block"
                          : "")
                      }
                      onClick={() =>
                        this.generateTaxPdf(
                          this.returnUnpayedDate("jul", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Plaćena godišnja faktura
                    </div> */}
                  </div>
                  <div
                    className={
                      "one_user_field_sub" + (oneUser.eighth_month != "0000-00-00" ? " payed_month" : " unpayed_month")
                    }
                  >
                    {oneUser.eighth_month != "0000-00-00"
                      ? Util.dateFormat(oneUser.eighth_month)
                      : Util.dateFormat(this.returnUnpayedDate("avgust", oneUser))}
                    <div
                      className={"pay_button" /* + (oneUser.eighth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("avgust", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečni predračun
                    </div>
                    <div
                      className={"pay_button" /* + (oneUser.eighth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("avgust", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Godišnji predračun
                    </div>
                    <div
                      className={"pay_button" + (oneUser.eighth_month != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.markAsPayed(this.returnUnpayedDate("avgust", oneUser), oneUser.id);

                        Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
                          title: "U redu",
                          css: "middle_popup_blue_button",
                          callback: () => {
                            window.location.reload(true);
                          },
                        });
                        this.generateTaxPdf(
                          this.returnUnpayedDate("avgust", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        );
                      }}
                    >
                      Označi kao plaćeno
                    </div>
                    <div
                      className={"pay_button" + (oneUser.eighth_month == "0000-00-00" ? " d_none" : "")}
                      onClick={() =>
                        this.findFacture(
                          this.returnUnpayedDate("avgust", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečna faktura
                    </div>
                    {/*           <div
                      className={
                        "pay_button_none" +
                        (oneUser.first_month != "0000-00-00" &&
                        oneUser.second_month != "0000-00-00" &&
                        oneUser.third_month != "0000-00-00" &&
                        oneUser.fourth_month != "0000-00-00" &&
                        oneUser.fifth_month != "0000-00-00" &&
                        oneUser.sixth_month != "0000-00-00" &&
                        oneUser.seventh_month != "0000-00-00" &&
                        oneUser.eighth_month != "0000-00-00" &&
                        oneUser.ninth_month != "0000-00-00" &&
                        oneUser.tenth_month != "0000-00-00" &&
                        oneUser.eleventh_month != "0000-00-00" &&
                        oneUser.twelfth_month != "0000-00-00"
                          ? " d_block"
                          : "")
                      }
                      onClick={() =>
                        this.generateTaxPdf(
                          this.returnUnpayedDate("avgust", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Plaćena godišnja faktura
                    </div> */}
                  </div>
                  <div
                    className={
                      "one_user_field_sub" + (oneUser.ninth_month != "0000-00-00" ? " payed_month" : " unpayed_month")
                    }
                  >
                    {oneUser.ninth_month != "0000-00-00"
                      ? Util.dateFormat(oneUser.ninth_month)
                      : Util.dateFormat(this.returnUnpayedDate("septembar", oneUser))}
                    <div
                      className={"pay_button" /* + (oneUser.ninth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("septembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečni predračun
                    </div>
                    <div
                      className={"pay_button" /* + (oneUser.ninth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("septembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Godišnji predračun
                    </div>
                    <div
                      className={"pay_button" + (oneUser.ninth_month != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.markAsPayed(this.returnUnpayedDate("septembar", oneUser), oneUser.id);

                        Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
                          title: "U redu",
                          css: "middle_popup_blue_button",
                          callback: () => {
                            window.location.reload(true);
                          },
                        });
                        this.generateTaxPdf(
                          this.returnUnpayedDate("septembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        );
                      }}
                    >
                      Označi kao plaćeno
                    </div>
                    <div
                      className={"pay_button" + (oneUser.ninth_month == "0000-00-00" ? " d_none" : "")}
                      onClick={() =>
                        this.findFacture(
                          this.returnUnpayedDate("septembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečna faktura
                    </div>
                    {/*        <div
                      className={
                        "pay_button_none" +
                        (oneUser.first_month != "0000-00-00" &&
                        oneUser.second_month != "0000-00-00" &&
                        oneUser.third_month != "0000-00-00" &&
                        oneUser.fourth_month != "0000-00-00" &&
                        oneUser.fifth_month != "0000-00-00" &&
                        oneUser.sixth_month != "0000-00-00" &&
                        oneUser.seventh_month != "0000-00-00" &&
                        oneUser.eighth_month != "0000-00-00" &&
                        oneUser.ninth_month != "0000-00-00" &&
                        oneUser.tenth_month != "0000-00-00" &&
                        oneUser.eleventh_month != "0000-00-00" &&
                        oneUser.twelfth_month != "0000-00-00"
                          ? " d_block"
                          : "")
                      }
                      onClick={() =>
                        this.generateTaxPdf(
                          this.returnUnpayedDate("septembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Plaćena godišnja faktura
                    </div> */}
                  </div>
                  <div
                    className={
                      "one_user_field_sub" + (oneUser.tenth_month != "0000-00-00" ? " payed_month" : " unpayed_month")
                    }
                  >
                    {oneUser.tenth_month != "0000-00-00"
                      ? Util.dateFormat(oneUser.tenth_month)
                      : Util.dateFormat(this.returnUnpayedDate("oktobar", oneUser))}
                    <div
                      className={"pay_button" /* + (oneUser.tenth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("oktobar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečni predračun
                    </div>
                    <div
                      className={"pay_button" /* + (oneUser.tenth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("oktobar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Godišnji predračun
                    </div>
                    <div
                      className={"pay_button" + (oneUser.tenth_month != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.markAsPayed(this.returnUnpayedDate("oktobar", oneUser), oneUser.id);

                        Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
                          title: "U redu",
                          css: "middle_popup_blue_button",
                          callback: () => {
                            window.location.reload(true);
                          },
                        });
                        this.generateTaxPdf(
                          this.returnUnpayedDate("oktobar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        );
                      }}
                    >
                      Označi kao plaćeno
                    </div>
                    <div
                      className={"pay_button" + (oneUser.tenth_month == "0000-00-00" ? " d_none" : "")}
                      onClick={() =>
                        this.findFacture(
                          this.returnUnpayedDate("oktobar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečna faktura
                    </div>
                    {/*          <div
                      className={
                        "pay_button_none" +
                        (oneUser.first_month != "0000-00-00" &&
                        oneUser.second_month != "0000-00-00" &&
                        oneUser.third_month != "0000-00-00" &&
                        oneUser.fourth_month != "0000-00-00" &&
                        oneUser.fifth_month != "0000-00-00" &&
                        oneUser.sixth_month != "0000-00-00" &&
                        oneUser.seventh_month != "0000-00-00" &&
                        oneUser.eighth_month != "0000-00-00" &&
                        oneUser.ninth_month != "0000-00-00" &&
                        oneUser.tenth_month != "0000-00-00" &&
                        oneUser.eleventh_month != "0000-00-00" &&
                        oneUser.twelfth_month != "0000-00-00"
                          ? " d_block"
                          : "")
                      }
                      onClick={() =>
                        this.generateTaxPdf(
                          this.returnUnpayedDate("oktobar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Plaćena godišnja faktura
                    </div> */}
                  </div>
                  <div
                    className={
                      "one_user_field_sub" +
                      (oneUser.eleventh_month != "0000-00-00" ? " payed_month" : " unpayed_month")
                    }
                  >
                    {oneUser.eleventh_month != "0000-00-00"
                      ? Util.dateFormat(oneUser.eleventh_month)
                      : Util.dateFormat(this.returnUnpayedDate("novembar", oneUser))}
                    <div
                      className={"pay_button" /* + (oneUser.eleventh_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("novembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečni predračun
                    </div>
                    <div
                      className={"pay_button" /* + (oneUser.eleventh_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("novembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Godišnji predračun
                    </div>
                    <div
                      className={"pay_button" + (oneUser.eleventh_month != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.markAsPayed(this.returnUnpayedDate("novembar", oneUser), oneUser.id);

                        Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
                          title: "U redu",
                          css: "middle_popup_blue_button",
                          callback: () => {
                            window.location.reload(true);
                          },
                        });
                        this.generateTaxPdf(
                          this.returnUnpayedDate("novembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        );
                      }}
                    >
                      Označi kao plaćeno
                    </div>
                    <div
                      className={"pay_button" + (oneUser.eleventh_month == "0000-00-00" ? " d_none" : "")}
                      onClick={() =>
                        this.findFacture(
                          this.returnUnpayedDate("novembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečna faktura
                    </div>
                    {/*        <div
                      className={
                        "pay_button_none" +
                        (oneUser.first_month != "0000-00-00" &&
                        oneUser.second_month != "0000-00-00" &&
                        oneUser.third_month != "0000-00-00" &&
                        oneUser.fourth_month != "0000-00-00" &&
                        oneUser.fifth_month != "0000-00-00" &&
                        oneUser.sixth_month != "0000-00-00" &&
                        oneUser.seventh_month != "0000-00-00" &&
                        oneUser.eighth_month != "0000-00-00" &&
                        oneUser.ninth_month != "0000-00-00" &&
                        oneUser.tenth_month != "0000-00-00" &&
                        oneUser.eleventh_month != "0000-00-00" &&
                        oneUser.twelfth_month != "0000-00-00"
                          ? " d_block"
                          : "")
                      }
                      onClick={() =>
                        this.generateTaxPdf(
                          this.returnUnpayedDate("novembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Plaćena godišnja faktura
                    </div> */}
                  </div>
                  <div
                    className={
                      "one_user_field_sub" + (oneUser.twelfth_month != "0000-00-00" ? " payed_month" : " unpayed_month")
                    }
                  >
                    {oneUser.twelfth_month != "0000-00-00"
                      ? Util.dateFormat(oneUser.twelfth_month)
                      : Util.dateFormat(this.returnUnpayedDate("decembar", oneUser))}
                    <div
                      className={"pay_button" /* + (oneUser.twelfth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("decembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečni predračun
                    </div>
                    <div
                      className={"pay_button" /* + (oneUser.twelfth_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("decembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Godišnji predračun
                    </div>
                    <div
                      className={"pay_button" + (oneUser.twelfth_month != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.markAsPayed(this.returnUnpayedDate("decembar", oneUser), oneUser.id);

                        Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
                          title: "U redu",
                          css: "middle_popup_blue_button",
                          callback: () => {
                            window.location.reload(true);
                          },
                        });
                        this.generateTaxPdf(
                          this.returnUnpayedDate("decembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        );
                      }}
                    >
                      Označi kao plaćeno
                    </div>
                    <div
                      className={"pay_button" + (oneUser.twelfth_month == "0000-00-00" ? " d_none" : "")}
                      onClick={() =>
                        this.findFacture(
                          this.returnUnpayedDate("decembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečna faktura
                    </div>
                    {/*             <div
                      className={
                        "pay_button_none" +
                        (oneUser.first_month != "0000-00-00" &&
                        oneUser.second_month != "0000-00-00" &&
                        oneUser.third_month != "0000-00-00" &&
                        oneUser.fourth_month != "0000-00-00" &&
                        oneUser.fifth_month != "0000-00-00" &&
                        oneUser.sixth_month != "0000-00-00" &&
                        oneUser.seventh_month != "0000-00-00" &&
                        oneUser.eighth_month != "0000-00-00" &&
                        oneUser.ninth_month != "0000-00-00" &&
                        oneUser.tenth_month != "0000-00-00" &&
                        oneUser.eleventh_month != "0000-00-00" &&
                        oneUser.twelfth_month != "0000-00-00"
                          ? " d_block"
                          : "")
                      }
                      onClick={() =>
                        this.generateTaxPdf(
                          this.returnUnpayedDate("decembar", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Plaćena godišnja faktura
                    </div> */}
                  </div>
                  <div
                    className={
                      "one_user_field_sub unpayed_month" /* + (oneUser.first_month != "0000-00-00" ? " payed_month" : " unpayed_month") */
                    }
                  >
                    {
                      /* oneUser.first_month != "0000-00-00"
                      ? Util.dateFormat(oneUser.first_month)
                      : */ Util.dateFormat(this.returnUnpayedDate("newYear", oneUser))
                    }
                    <div
                      className={"pay_button" /* + (oneUser.first_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("newYear", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečni predračun
                    </div>
                    <div
                      className={"pay_button" /* + (oneUser.first_month != "0000-00-00" ? " d_none" : "") */}
                      onClick={() =>
                        this.generatePdf(
                          this.returnUnpayedDate("newYear", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Godišnji predračun
                    </div>
                    <div
                      className={"pay_button" + (oneUser.first_month != "0000-00-00" ? " d_none" : "")}
                      onClick={() => {
                        this.markAsPayed(this.returnUnpayedDate("newYear", oneUser), oneUser.id);

                        Util.showPopupDialog("Obavještenje", "Uplata korisnika " + oneUser.username + " je obrađena.", {
                          title: "U redu",
                          css: "middle_popup_blue_button",
                          callback: () => {
                            window.location.reload(true);
                          },
                        });
                        this.generateTaxPdf(
                          this.returnUnpayedDate("newYear", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        );
                      }}
                    >
                      Označi kao plaćeno
                    </div>
                    <div
                      className={"pay_button" + (oneUser.first_month == "0000-00-00" ? " d_none" : "")}
                      onClick={() =>
                        this.findFacture(
                          this.returnUnpayedDate("newYear", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "normal"
                        )
                      }
                    >
                      Mjesečna faktura
                    </div>
                    {/*           <div
                      className={
                        "pay_button_none" +
                        (oneUser.first_month != "0000-00-00" &&
                        oneUser.second_month != "0000-00-00" &&
                        oneUser.third_month != "0000-00-00" &&
                        oneUser.fourth_month != "0000-00-00" &&
                        oneUser.fifth_month != "0000-00-00" &&
                        oneUser.sixth_month != "0000-00-00" &&
                        oneUser.seventh_month != "0000-00-00" &&
                        oneUser.eighth_month != "0000-00-00" &&
                        oneUser.ninth_month != "0000-00-00" &&
                        oneUser.tenth_month != "0000-00-00" &&
                        oneUser.eleventh_month != "0000-00-00" &&
                        oneUser.twelfth_month != "0000-00-00"
                          ? " d_block"
                          : "")
                      }
                      onClick={() =>
                        this.generateTaxPdf(
                          this.returnUnpayedDate("newYear", oneUser),
                          oneUser.id,
                          oneUser.username,
                          "year"
                        )
                      }
                    >
                      Plaćena godišnja faktura
                    </div> */}
                  </div>
                  <div className="one_user_field_sub">{oneUser.facture_number}</div>
                  <div className="one_user_field_sub">{oneUser.facture_address}</div>
                  <div className="one_user_field_sub last_item_sub">{oneUser.status}</div>
                </div>
              ))}
            </div>
          )}
          {this.state.currentTab == "expired" && (
            <div className="sub_plan_section">
              <div className="sub_plan_section_title expired_tab">
                Lista korisnika kojima je uplata istekla i ne žele da je produže
              </div>
              <div className="one_user_header_sub expired_tab">
                <div className="one_user_field_sub " style={{ width: "50px" }}>
                  ID
                </div>
                <div className="one_user_field_sub ">Korisničko ime</div>
                <div className="one_user_field_sub ">Email</div>
                <div className="one_user_field_sub ">Telefon</div>
                <div className="one_user_field_sub ">Registrovan</div>
                <div className="one_user_field_sub ">Dodat prvi proizvod</div>
                <div className="one_user_field_sub ">Poslednja aktivnost</div>
                <div className="one_user_field_sub ">Datum prestanka</div>
                <div className="one_user_field_sub ">Uplaćeni mjeseci</div>
                <div className="one_user_field_sub last_item_sub">Status</div>
              </div>
              {this.state.usersExpired.map((oneUser, i) => (
                <div className="one_user_item_sub expired_tab" key={i}>
                  <div className="one_user_field_sub " style={{ width: "50px" }}>
                    {oneUser.id}
                  </div>
                  <div
                    style={{
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                    className="one_user_field_sub"
                  >
                    <span>{oneUser.username}</span>
                    <div className="users_name_lastname">
                      {oneUser.first_name} {oneUser.last_name}
                      <div
                        className="pay_button"
                        onClick={() => {
                          this.setState(
                            {
                              showInputData: true,
                              oneuser: oneUser,
                              user_id: oneUser.id,
                              user_logged: oneUser.registered,
                              start_date: Util.defDate(oneUser.registered),
                            },
                            this.showpPayingPopup(oneUser)
                          );
                        }}
                      >
                        Plaćanje
                      </div>
                    </div>
                  </div>
                  <div className="one_user_field_sub">{oneUser.email}</div>
                  <div className="one_user_field_sub">{oneUser.phone}</div>
                  <div className="one_user_field_sub">{Util.dateTimeFormat(oneUser.registered)}</div>
                  <div className="one_user_field_sub">{Util.dateTimeFormat(oneUser.first_product_added)}</div>
                  <div className="one_user_field_sub">{Util.dateTimeFormat(oneUser.last_time_logged)}</div>
                  <div className="one_user_field_sub">{Util.dateFormat(oneUser.pay_end_date)}</div>
                  <div className="one_user_field_sub">
                    <div className="one_row">
                      {oneUser.first_month != "0000-00-00" ? Util.dateFormat(oneUser.first_month) : ""}
                    </div>
                    <div className="one_row">
                      {oneUser.second_month != "0000-00-00" ? Util.dateFormat(oneUser.second_month) : ""}
                    </div>
                    <div className="one_row">
                      {oneUser.third_month != "0000-00-00" ? Util.dateFormat(oneUser.third_month) : ""}
                    </div>
                    <div className="one_row">
                      {" "}
                      {oneUser.fourth_month != "0000-00-00" ? Util.dateFormat(oneUser.fourth_month) : ""}
                    </div>
                    <div className="one_row">
                      {" "}
                      {oneUser.fifth_month != "0000-00-00" ? Util.dateFormat(oneUser.fifth_month) : ""}
                    </div>
                    <div className="one_row">
                      {" "}
                      {oneUser.sixth_month != "0000-00-00" ? Util.dateFormat(oneUser.sixth_month) : ""}
                    </div>
                    <div className="one_row">
                      {" "}
                      {oneUser.seventh_month != "0000-00-00" ? Util.dateFormat(oneUser.seventh_month) : ""}
                    </div>
                    <div className="one_row">
                      {" "}
                      {oneUser.eighth_month != "0000-00-00" ? Util.dateFormat(oneUser.eighth_month) : ""}
                    </div>
                    <div className="one_row">
                      {" "}
                      {oneUser.ninth_month != "0000-00-00" ? Util.dateFormat(oneUser.ninth_month) : ""}
                    </div>
                    <div className="one_row">
                      {oneUser.tenth_month != "0000-00-00" ? Util.dateFormat(oneUser.tenth_month) : ""}
                    </div>
                    <div className="one_row">
                      {" "}
                      {oneUser.eleventh_month != "0000-00-00" ? Util.dateFormat(oneUser.eleventh_month) : ""}
                    </div>
                    <div className="one_row">
                      {" "}
                      {oneUser.twelfth_month != "0000-00-00" ? Util.dateFormat(oneUser.twelfth_month) : ""}
                    </div>
                  </div>
                  <div className="one_user_field_sub last_item_sub">{oneUser.status}</div>
                </div>
              ))}
            </div>
          )}
          {this.state.currentTab == "check" && (
            <div className="sub_plan_section">
              <div className="sub_plan_section_title check_tab">
                Lista korisnika kojima uplata ističe u narednih 5 dana
              </div>
              <div className="one_user_header_sub check_tab">
                <div className="one_user_field_sub " style={{ width: "50px" }}>
                  ID
                </div>
                <div className="one_user_field_sub ">Korisničko ime</div>
                <div className="one_user_field_sub ">Email</div>
                <div className="one_user_field_sub ">Telefon</div>
                <div className="one_user_field_sub ">Poslednja aktivnost</div>
                <div className="one_user_field_sub ">Poslednja uplata</div>
                <div className="one_user_field_sub">
                  Dana od zadnje <br />
                  uplate
                </div>
                <div className="one_user_field_sub">Očekivana uplata</div>

                <div className="one_user_field_sub">Broj fakture</div>
                <div className="one_user_field_sub">Adresa fakture</div>
                <div className="one_user_field_sub last_item_sub">Status</div>
              </div>
              {this.state.users_list.map((oneUser, i) => (
                <div className="one_user_item_sub check_tab" key={i}>
                  <div className="one_user_field_sub " style={{ width: "50px" }}>
                    {oneUser.userid}
                  </div>
                  <div
                    style={{
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                    className="one_user_field_sub"
                  >
                    <span>{oneUser.username}</span>
                    <div className="users_name_lastname">
                      {oneUser.first_name} {oneUser.last_name}
                      <div>
                        <span>{oneUser.pay_name}</span>
                      </div>
                      <div
                        className="pay_button"
                        onClick={() => {
                          this.directPaying(oneUser);
                        }}
                      >
                        Redovna uplata
                      </div>
                      <div
                        className="pay_button"
                        onClick={() => {
                          this.lostPaymentpopup(oneUser);
                          this.setState({ showPay: true });
                        }}
                      >
                        Vanredna uplata
                      </div>
                      <div
                        className="refuse_pay_button"
                        onClick={() => {
                          this.showNotPayingPopup(oneUser.userid);
                        }}
                      >
                        Odustaje
                      </div>
                    </div>
                  </div>
                  <div className="one_user_field_sub">{oneUser.pay_email}</div>
                  <div className="one_user_field_sub">{oneUser.pay_phone}</div>
                  <div className="one_user_field_sub">{Util.dateTimeFormat(oneUser.last_time_logged)}</div>
                  <div className="one_user_field_sub">{Util.dateFormat(oneUser.last_payment)}</div>
                  <div
                    className={
                      "one_user_field_sub" +
                      (this.differenceInTime(oneUser.last_payment) == 29 ? " payment_will_expire" : "")
                    }
                  >
                    {this.differenceInTime(oneUser.last_payment)}
                    <br />
                  </div>
                  <div className="one_user_field_sub">{Util.dateFormat(Util.defDate(oneUser.last_payment))}</div>

                  <div className="one_user_field_sub">{oneUser.facture_number}</div>
                  <div className="one_user_field_sub">{oneUser.facture_address}</div>
                  <div className="one_user_field_sub last_item_sub">{oneUser.status}</div>
                </div>
              ))}
            </div>
          )}
        </div>
        {this.state.showInputData == true && (
          <div className="middle_popup">
            <div className="middle_popup_inside">
              <div className="middle_popup_close" onClick={this.backToUsers}>
                &times;
              </div>
              <div className="middle_popup_title">Unesite podatke</div>
              <div className="middle_popup_body">
                <div className="middle_popup_body_padding">
                  <div>
                    <input
                      className="input_popup"
                      type="text"
                      placeholder="Naziv"
                      value={this.state.user_username}
                      id="sub_username"
                      onChange={this.handleChangeUsername}
                    />
                  </div>
                  <div>
                    <input
                      className="input_popup"
                      type="text"
                      placeholder="Adresa"
                      value={this.state.user_address}
                      id="sub_address"
                      onChange={this.handleChangeAddress}
                    />
                  </div>
                  <div>
                    <input
                      className="input_popup"
                      type="text"
                      placeholder="JIB"
                      value={this.state.user_jib}
                      id="sub_jib"
                      onChange={this.handleChangeJIB}
                    />
                  </div>
                  <div>
                    <input
                      className="input_popup"
                      type="text"
                      placeholder="PDV"
                      value={this.state.user_pdv}
                      id="sub_pdv"
                      onChange={this.handleChangePDV}
                    />
                  </div>
                  <div>
                    <input
                      className="input_popup"
                      type="text"
                      placeholder="Broj telefona"
                      value={this.state.user_phone}
                      id="sub_phone"
                      onChange={this.handleChangePhone}
                    />
                  </div>
                  <div>
                    <input
                      className="input_popup"
                      type="text"
                      placeholder="Email"
                      value={this.state.user_email}
                      id="sub_email"
                      onChange={this.handleChangeEmail}
                    />
                  </div>
                  <div style={{ position: "relative" }}>
                    <input
                      className="input_popup input_with_calendar"
                      type="text"
                      placeholder="Početni dan"
                      id="sub_startDate"
                      value={Util.dateFormat(this.state.start_date)}
                      onFocus={this.showCalendar}
                      onChange={this.handleChangeReg}
                    />
                    {this.state.showCalendar == true && (
                      <div className="input_with_calendar mg_left" onMouseLeave={this.showCalendar}>
                        <Calendar updateChild={this.updateChild} />
                      </div>
                    )}
                  </div>
                  <div>
                    <input
                      className="input_popup"
                      type="text"
                      placeholder="Predračun na:"
                      value={this.state.facture_address}
                      id="facture_address"
                      onChange={this.handleChangeFacture}
                    />
                  </div>
                  <div>
                    <input
                      className="input_popup"
                      type="text"
                      placeholder="Predračun broj:"
                      value={this.state.facture_number}
                      id="facture_number"
                      onChange={this.handleChangeFactureNumber}
                    />
                  </div>
                  <div className="sub_popup_confirm" onClick={this.factureData}>
                    Potvrdi
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.showPay == true && (
          <div className="middle_popup">
            <div className="middle_popup_inside">
              <div className="middle_popup_close" onClick={this.backToUsers}>
                &times;
              </div>
              <div className="middle_popup_title">Označite mjesece koje korisnik uplaćuje</div>
              <div className="sub_title_popup"> </div>
              <div className="middle_popup_body">
                <div className="middle_popup_body_padding">
                  {this.state.lost_months.map((oneMonth, i) => (
                    <div key={i}>
                      <div className="checkbox_area">
                        <input
                          type="checkbox"
                          value={oneMonth}
                          onChange={(e) => this.handleChekbox(e)}
                          className="checkbox_edt"
                        />
                        <div className="dates_show">{Util.dateFormat(oneMonth)}</div>
                      </div>
                    </div>
                  ))}
                  <div className="sub_popup_confirm" onClick={this.payLostMonths}>
                    Potvrdi
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.showFirstPay == true && (
          <div className="middle_popup">
            <div className="middle_popup_inside">
              <div className="middle_popup_close" onClick={this.backToUsers}>
                &times;
              </div>
              <div className="middle_popup_title">Odaberite datum</div>
              <div>
                <div className="middle_popup_body">
                  <div className="middle_popup_body_padding firstpay_popup">
                    <div style={{ position: "relative" }}>
                      <input
                        className="input_popup input_with_calendar first_pay_input"
                        type="text"
                        placeholder="Početni dan"
                        id="sub_startDate"
                        value={Util.dateFormat(this.state.firstDate)}
                        onFocus={this.showCalendar}
                        onChange={this.handleChangeReg}
                      />
                      <div className="input_with_calendar mg_left">
                        <Calendar updateChild={this.updateChild} showFirstPay={this.state.showFirstPay} />
                      </div>
                    </div>
                    <div className="sub_popup_confirm first_pay_btn" onClick={this.firstPayment}>
                      Potvrdi uplatu
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className={"loader_holder" + (this.state.addingPDF ? " active" : "")}>
          <div className="loader_big"></div>
        </div>
      </>
    );
  }
}

export default PlanSubscription;
